import React, { Fragment } from 'react'
import { Text, Input } from 'components/base'

const ATLASSIAN_API_TOKEN_SETTING_PAGE =
  'https://id.atlassian.com/manage/api-tokens'

const ConfluenceSettingsForm = ({
  onChange,
  values: { domainName, email, apiToken },
}) => (
  <Fragment>
    <Text.Title className="margin-bottom-small">Confluence settings</Text.Title>
    <p className="font-family-system font-size-normal shade-20 margin-bottom-large">
      The following settings are required to properly import your confluence
      spaces. You need to provide your Atlassian domain name, your account email
      address and your Confluence API token that you will be able to get from{' '}
      <Text.ExternalLink
        inline
        target="_blank"
        rel="noopener noreferrer"
        href={ATLASSIAN_API_TOKEN_SETTING_PAGE}
      >
        here
      </Text.ExternalLink>
    </p>
    <div>
      <Input
        placeholder="Domain name"
        value={domainName}
        onChange={event =>
          onChange({ domainName: event.target.value, email, apiToken })
        }
      />
      <Input
        placeholder="Email"
        value={email}
        onChange={event =>
          onChange({ email: event.target.value, domainName, apiToken })
        }
      />
      <Input
        placeholder="API token"
        value={apiToken}
        onChange={event =>
          onChange({ apiToken: event.target.value, email, domainName })
        }
      />
    </div>
  </Fragment>
)

export default ConfluenceSettingsForm
